import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Color } from '@figure/frontlib-gui';

const Button = styled.button`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  appearance: none;
  margin-left: 10px;
  vertical-align: top;
`;

const ToggleDropdown = ({ active, handleClick }) => (
  <Button onClick={handleClick}>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d={active ? 'M12 10.0001L8 6.18188L4 10.0001' : 'M4 5.99993L8 9.81812L12 5.99993'}
        stroke={Color.DARK_GREY}
        strokeWidth="1.5"
      />
      <rect x="15.5" y="15.5" width="15" height="15" transform="rotate(-180 15.5 15.5)" stroke={Color.DARK_GREY} />
    </svg>
  </Button>
);

ToggleDropdown.propTypes = {
  active: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
};

ToggleDropdown.defaultProps = {
  active: false,
};

export default ToggleDropdown;
